export const configureFormCustomDataSubtitle =
  'Use custom data to implement enhanced offer mechanics in your app and other channels.';
